import React from "react";
import Referral from "../../component/Referral/Referral.tsx";

const ReferralPage = () => {
  return (
    <div>
      <Referral />
    </div>
  );
};

export default ReferralPage;
